import ApplicationModel, { attr } from '../ApplicationModel';
import { type PresentationAttributes } from './generated/PresentationAttributes';
import { model } from '../modelBuilder';
import Fragment from '../Fragment';

interface Presentation extends PresentationAttributes {}

@model
class Presentation extends ApplicationModel {
  // Start auto-generated
  static typename: 'Presentation' = 'Presentation';
  get typename(): 'Presentation' {
    return 'Presentation';
  }

  static internalTypename: 'Presentation' = 'Presentation';
  get internalTypename(): 'Presentation' {
    return 'Presentation';
  }

  static fields = {
    commentsCount: attr({ readable: true }),
    createdAt: attr({ readable: true }),
    editorContent: attr({ readable: true, json: true }),
    id: attr({ readable: true }),
    name: attr({ readable: true }),
    path: attr({ readable: true }),
    slidesCount: attr({ readable: true }),
    updatedAt: attr({ readable: true }),
    watchersCount: attr({ readable: true }),
    user: attr.belongsTo({ readable: true, typename: 'User' }),
    comments: attr.hasMany({ readable: true }),
    slides: attr.hasMany({ readable: true }),
    tasks: attr.hasMany({ readable: true }),
    watchers: attr.hasMany({ readable: true }),
  };
  // End auto-generated

  async createSlide(): Promise<RecordId> {
    return Presentation.createSlide(this.id);
  }

  async removeSlide(slideId: RecordId): Promise<RecordId> {
    return Presentation.removeSlide(this.id, slideId);
  }

  static async createSlide(presentationId: RecordId): Promise<RecordId> {
    const data = await ApplicationModel.mutate(
      new Fragment('createSlide')
        .argument('presentationId', presentationId)
        .argument('__reactivelyUpdate', true)
        .fragment(new Fragment('slide').attr('id'))
    );

    if (data.createSlide.errors) {
      throw data.createSlide.errors;
    }

    return data.createSlide.slide.id;
  }

  static async removeSlide(
    presentationId: RecordId,
    slideId: RecordId
  ): Promise<RecordId> {
    const data = await ApplicationModel.mutate(
      new Fragment('deleteSlide')
        .argument('presentationId', presentationId)
        .argument('slideId', slideId)
        .argument('__reactivelyUpdate', true)
        .fragment(new Fragment('slide').attr('id'))
    );

    if (data.deleteSlide.errors) {
      throw data.deleteSlide.errors;
    }

    return data.deleteSlide.slide.id;
  }
}

export default Presentation;
